export const CONFIG = {
  "PROJECTNAME": "demo",
  "COMPANYNAME": "Demo",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "19999075",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": true,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": true,
  "colors": {
    "primary": "#e0241B",
    "primary100": "#F2CECC",
    "light": "#e0241B",
    "secondary": "#e0241B",
    "dark": "#e0241B",
    "siteColor3": "#fff",
    "menuSecondary": "#e0241B"
  }
};